import React, { useContext, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";
import ConfirmCancel from "../../../components/DialogComponent/ConfirmCancel";
import DialogComponent from "../../../components/DialogComponent/DialogComponent";
import {  Save, ArrowRight, Building } from "lucide-react";
import { useEffect } from "react";
import {
  CommonConfirmationDialog,
  StorageLimitAccess,
} from "../../../components/DialogComponent/SupplyDataDialog";
import AuthContext from "../../../hooks/authContext";
import { useParams } from "react-router";
import { getClientsList } from "../../../services/apiservices/client";
import { getAllEmployee } from "../../../services/apiservices/employee";
import { packageAccess } from "../../../services/helpers";
import styles from "../clients.module.scss";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { useMediaQuery } from "@mui/material";
import { Input } from "../../../components/ui/input";
import { Textarea } from "../../../components/ui/textArea";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import { Button } from "../../../components/ui/button";
import { US_STATES } from "../../../components/USStateConstant";

// const stepId = 1; // Not currently used

function isAddressMatch(address1, address2) {
  return (
    address1.city === address2.city &&
    address1.state === address2.state &&
    address1.lng === address2.lng &&
    address1.lat === address2.lat &&
    address1.address === address2.address &&
    address1.zip === address2.zip
  );
}

function Step1(props) {
  // const [stepContent, setStepContent] = useState({
  //   summaryReportFrequency: "Not Required",
  // });
  // const [stepError, setStepError] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [storageDialog, setStorageDialog] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [map, setMap] = useState(false);
  const [clientRes, setClientRes] = useState();
  // eslint-disable-next-line no-unused-vars
  const [companyDetails, setCompanyDetails] = useState([]);
  const { clientId } = useParams();
  const auth = useContext(AuthContext);
  const userPackageId = auth?.userProfile?.prdId;
  const userPromocode = auth?.userProfile?.userPromoCode || auth?.userProfile?.companyData?.userPromoCode;
  const subscriptionId = auth?.userProfile?.subscriptionDetails?.scheduleId || auth?.userProfile?.subscriptions?.data?.[0]?.scheduleId;
  const allowedPermissions = packageAccess(userPackageId, userPromocode, subscriptionId);
  const id = clientId ? clientId : auth?.newClientId;
  const isMobile = useMediaQuery("(max-width:767px)");

  const {
    // eslint-disable-next-line no-unused-vars
    currentStep,
    // eslint-disable-next-line no-unused-vars
    goToStep,
    onCancelAll,
    stepContentValues,
    loading,
    // eslint-disable-next-line no-unused-vars
    classes,
    stepContent,
    setStepContent,
    stepError,
    setStepError
  } = props;

  const allIndustryTypes = [
    "Retail",
    "Medical",
    "Industrial",
    "Restaurant",
    "Office",
    "Other",
  ].map((IndustyItem) => {
    return {
      label: `${IndustyItem}`,
      value: IndustyItem,
    };
  });
  const allFrequency = ["Not Required", "Daily", "Monthly", "Weekly"].map(
    (frequencyItem) => {
      return {
        label: `${frequencyItem}`,
        value: frequencyItem,
      };
    }
  );

  const selectedValues = [
    { label: "EDT - Eastern", value: "America/New_York" },
    { label: "CDT - Central", value: "America/Chicago" },
    { label: "MDT - Mountain", value: "America/Denver" },
    { label: "PDT - Pacific", value: "America/Los_Angeles" },
  ];

  const setEditData = (editData) => {
    setStepContent({
      clientName: editData?.clientName ? editData?.clientName : "",
      companyName: editData?.companyName ? editData?.companyName : "",
      firstName: editData?.firstName ? editData?.firstName : "",
      lastName: editData?.lastName ? editData?.lastName : "",
      clientLogo: editData?.clientLogo ? editData?.clientLogo : "",
      industryType: editData?.industryType ? editData?.industryType : "",
      industryTypeOther: editData?.industryTypeOther
        ? editData?.industryTypeOther
        : "",
      summaryReportFrequency: editData?.summaryReportFrequency
        ? editData?.summaryReportFrequency
        : "",
      timeZone: editData?.timeZone ? editData?.timeZone : "",
      clientAddress: editData?.clientAddress ? editData?.clientAddress : "",
      clientLocation: editData?.clientLocation ? editData?.clientLocation : "",
      addressInfo: editData?.addressInfo
      ? editData?.addressInfo
      : { city: "", state: "", country: "", zip: "", address: "" },
      additionalNotes: editData?.additionalNotes ? editData?.additionalNotes : "",
    });
  };
  useEffect(() => {
    if (props?.editData !== false) {
      setEditData(props?.editData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.editData]); // setEditData is a wrapper function, stable

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (props?.displayStep == 1 && stepContentValues?.stepContent) {
      setEditData(stepContentValues?.stepContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.displayStep, stepContentValues]); // setEditData is stable from useState, doesn't need to be in deps

  const getAllClients = () => {
    getClientsList({}, (res) => {
      if (res) {
        setClientRes(res);
      } else {
        setClientRes();
      }
    });
  };

  const getAllEmployeeData = () => {
    getAllEmployee((res) => {
      if (res) {
        const data = res?.data?.filter((item) => item.role === "companyUser");
        const companyNames = data.map((res) => ({
          value: res?.id,
          label: `${res?.firstName} ${res?.lastName}`,
          name: `${res?.firstName} ${res?.lastName}`,
          firstName: res?.firstName,
          lastName: res?.lastName,
        }));
        setCompanyDetails(companyNames);
      } else {
        setCompanyDetails([]);
      }
    });
  };

  useEffect(() => {
    getAllClients();
    getAllEmployeeData();
  }, []);

  const handleSingleSelectChange = (name) => (value) => {
  setStepContent((prev) => ({
    ...prev,
    [name]: value,
  }));

  setStepError((prev) => ({
    ...prev,
    [name]: "",
  }));
};

  const handleInputChange = (event) => {
    const {
      target: { name, value },
    } = event;

    if (name === "clientName") {
      setStepContent({
        ...stepContent,
        clientName: value,
        firstName: value,
        lastName: value,
      });
      setStepError({
        ...stepError,
        clientName: "",
        firstName: "",
        lastName: "",
      });
    } else {
      setStepContent({ ...stepContent, [name]: value });
      setStepError({ ...stepError, [name]: "" });
    }
  };

  const handelUpdateAddress = () => {
    props?.validateAndGoNext &&
      props?.validateAndGoNext({ stepContent }, { step1: true });
    setDialogOpen(false);
  };

  const handelCloseDailog = () => {
    setDialogOpen(false);
  };

  const handleDialogClose = () => {
    setStorageDialog(false);
  };

  const validateAndGoNext = () => {
    const {
      clientName,
      industryType,
      industryTypeOther,
      summaryReportFrequency,
      firstName,
      lastName,
      timeZone,
      companyId,
      addressInfo,
    } = stepContent;

    let errormessages = stepError;
    let isValid = true;
    if (
      typeof clientName === "undefined" ||
      clientName === undefined ||
      clientName === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        clientName: "Company Name is Required",
      };
    }
    if (
      typeof firstName === "undefined" ||
      firstName === undefined ||
      firstName === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        firstName: "First Name is Required",
      };
    }
    if (
      typeof lastName === "undefined" ||
      lastName === undefined ||
      lastName === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        lastName: "Last Name is Required",
      };
    }
    if (typeof industryType === "undefined" || industryType === "") {
      isValid = false;
      errormessages = {
        ...errormessages,
        industryType: "Industry Type is Required",
      };
    } else if (
      industryType === "Other" &&
      (typeof industryTypeOther === "undefined" || industryTypeOther === "")
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        industryTypeOther: "Industry Type Name is Required",
      };
    } else {
      errormessages = {
        ...errormessages,
        industryType: "",
        industryTypeOther: "",
      };
    }
    if (
      typeof summaryReportFrequency == "undefined" ||
      summaryReportFrequency === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        summaryReportFrequency: "Summary Report Frequency is Required",
      };
    } else {
      errormessages = { ...errormessages, summaryReportFrequency: "" };
    }
    if (typeof timeZone == "undefined" || timeZone === "") {
      isValid = false;
      errormessages = {
        ...errormessages,
        timeZone: "Time Zone is Required",
      };
    } else {
      errormessages = { ...errormessages, timeZone: "" };
    }
    if (auth.userProfile.role === "superUser") {
      if (typeof companyId == "undefined" || companyId === "") {
        isValid = false;
        errormessages = {
          ...errormessages,
          companyId: "Company is Required",
        };
      } else {
        errormessages = { ...errormessages, timeZone: "" };
      }
    }
    // Validate Address Information
    if (!addressInfo?.address || addressInfo?.address.trim() === "") {
      isValid = false;
      errormessages.address = "Address is Required";
    } else {
      errormessages.address = "";
    }
    if (!addressInfo?.city || addressInfo?.city.trim() === "") {
      isValid = false;
      errormessages.city = "City is Required";
    } else {
      errormessages.city = "";
    }
    if (!addressInfo?.state || addressInfo?.state.trim() === "") {
      isValid = false;
      errormessages.state = "State is Required";
    } else {
      errormessages.state = "";
    }
    if (!addressInfo?.zip || addressInfo?.zip.trim() === "") {
      isValid = false;
      errormessages.zip = "Zip Code is Required";
    } else {
      errormessages.zip = "";
    }
    setStepError(errormessages);
    if (isValid) {
      if (id) {
        const details = clientRes?.find((item) => item.id === id);
        const isAddressChanged = !isAddressMatch(
          details?.addressInfo,
          stepContent?.addressInfo
        );
        if (isAddressChanged) {
          setDialogOpen(true);
        } else {
          props?.validateAndGoNext &&
            props.validateAndGoNext({ stepContent }, { step1: true });
        }
      } else {
        props?.validateAndGoNext &&
          props.validateAndGoNext({ stepContent }, { step1: true });
      }
    }
  };

  const onClose = () => {
    handleInputChange({ target: { name: "clientLogo", value: null } });
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const maxSizeInBytes = 2 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      setStepError((prevError) => ({
        ...prevError,
        clientLogo: "Logo size must be 2MB or less",
      }));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      onCrop(base64);
    };
    reader.readAsDataURL(file);
  };

  const onCrop = (preview) => {
    const extraLimit = auth?.userProfile?.additionalQuantity * 5;
    const extraLimitInBytes = extraLimit * 1024 ** 3;
    const storageLimit =
      (allowedPermissions?.storageLimits ?? 0) + extraLimitInBytes;
    const base64Data = preview.split(",")[1];
    const byteSize = Math.ceil((base64Data.length * 3) / 4);

    if (auth?.userProfile?.storage + byteSize > storageLimit) {
      setStorageDialog(true);
      return;
    }
    handleInputChange({ target: { name: "clientLogo", value: preview } });
  };
  const clearFields = (updatedInfo, fields) => {
    fields.forEach((field) => {
      updatedInfo[field] = "";
    });
  };
  const handleManualAddressChange = (field, value) => {
    setStepContent((prevContent) => {
      const currentAddressInfo = prevContent.addressInfo || {};

      const updatedAddressInfo = {
        ...currentAddressInfo,
        [field]: value,
      };

      const isAddressChanged =
        currentAddressInfo.address !== updatedAddressInfo.address;
      const isCityChanged = currentAddressInfo.city !== updatedAddressInfo.city;
      const isStateChanged =
        currentAddressInfo.state !== updatedAddressInfo.state;

      if (!updatedAddressInfo.address || isAddressChanged) {
        clearFields(updatedAddressInfo, ["city", "state", "zip", "lat", "lng"]);
      } else if (!updatedAddressInfo.city || isCityChanged) {
        clearFields(updatedAddressInfo, ["state", "zip", "lat", "lng"]);
      } else if (!updatedAddressInfo.state || isStateChanged) {
        clearFields(updatedAddressInfo, ["zip", "lat", "lng"]);
      }

      return {
        ...prevContent,
        addressInfo: updatedAddressInfo,
      };
    });
    setStepError((prevError) => ({
      ...prevError,
      [`addressInfo.${field}`]:
        !value || value.trim() === ""
          ? `${field.charAt(0).toUpperCase() + field.slice(1)} is required`
          : "",
    }));
  };

  // eslint-disable-next-line no-unused-vars
  const onChangeAddress = (updatedAddressInfo) => {
    setStepContent((prev) => ({
      ...prev,
      addressInfo: updatedAddressInfo,
    }));
    setStepError((prevError) => ({
      ...prevError,
      "addressInfo.address": !updatedAddressInfo.address
        ? "Address is required"
        : "",
      "addressInfo.city": !updatedAddressInfo.city ? "City is required" : "",
      "addressInfo.state": !updatedAddressInfo.state ? "State is required" : "",
      "addressInfo.zip": !updatedAddressInfo.zip ? "Zip is required" : "",
    }));
  };

  return (
    <>
      <div className="mv-15">
        <Card className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]` }>
          <CardContent className="p-24">
            <div className="d-flex flex-center flex-space-between mb-24">
              <h2 className={`${styles.cardProfileTitle} dark:text-white`}>
                <Building className="h-5 w-5 mr-2.5 color-primary" />
                Company Details
              </h2>
            </div>

            <div className={styles.gridLayout}>
              <div className={styles.fieldGroup}>
                <div>
                  <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                    Company Name
                  </Typography>
                  <div className="mt-5">
                    <Input
                      id="clientName"
                      name="clientName"
                      value={stepContent?.clientName || ""}
                      onChange={handleInputChange}
                      placeholder="Enter company name *"
                      tabIndex={1}
                    />
                  </div>
                  {stepError?.clientName && (
                    <span className="small error color-danger">
                      {stepError.clientName}
                    </span>
                  )}
                </div>

                <div>
                  <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                    Summary Report Frequency
                  </Typography>
                  <div className="mt-5">
                    <SingleSelectNew
                      value={
                        stepContent?.summaryReportFrequency || "Not Required"
                      }
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      name={"summaryReportFrequency"}
                      placeholder="Summary Report Frequency"
                      onChange={handleSingleSelectChange('summaryReportFrequency')}
                      options={[...allFrequency]}
                      tabIndex={2}
                    />
                  </div>
                  {stepError?.summaryReportFrequency && (
                    <span className="small error color-danger">
                      {stepError.summaryReportFrequency}
                    </span>
                  )}
                </div>

                <div>
                  <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                    TimeZone
                  </Typography>
                  <div className="mt-5">
                    <SingleSelectNew
                      name="timeZone"
                      id="timeZone"
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      placeholder="TimeZone *"
                      value={stepContent?.timeZone}
                      onChange={handleSingleSelectChange('timeZone')}
                      options={selectedValues}
                      tabIndex={3}
                    />
                  </div>
                  {stepError?.timeZone && (
                    <span className="small error color-danger">
                      {stepError.timeZone}
                    </span>
                  )}
                </div>
                <div>
                  <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                    Industry Type
                  </Typography>
                  <div className="mt-5">
                    <div className="formFieldwrap">
                      <SingleSelectNew
                        value={
                          stepContent?.industryType
                            ? stepContent?.industryType
                            : ""
                        }
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        placeholder="Industry Type *"
                        name={"industryType"}
                        onChange={handleSingleSelectChange('industryType')}
                        options={[...allIndustryTypes]}
                        tabIndex={4}
                      />
                      {typeof stepError?.industryType !== "undefined" &&
                        stepError?.industryType !== "" && (
                          <span className="small error color-danger">
                            {stepError?.industryType}
                          </span>
                        )}
                    </div>
                    {stepContent?.industryType &&
                    stepContent?.industryType === "Other" ? (
                      <div className="formFieldwrap">
                        <Input
                          name="industryTypeOther"
                          id="industryTypeOther"
                          placeholder="Industry Type Name *"
                          onChange={handleInputChange}
                          value={
                            stepContent?.industryTypeOther
                              ? stepContent?.industryTypeOther
                              : ""
                          }
                          tabIndex={5}
                        />
                        {typeof stepError?.industryTypeOther !== "undefined" &&
                          stepError?.industryTypeOther !== "" && (
                            <span className="small error color-danger">
                              {stepError?.industryTypeOther}
                            </span>
                          )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div>
                <Typography className={`${styles.labelSm} dark:text-white`}>Company Logo</Typography>
                <div className={`${styles.logoContainer} dark:bg-[#1A1F2C]`}>
                  {stepContent?.clientLogo ? (
                    <div className={styles.logoPreviewWrapper}>
                      <div className={styles.logoPreviewImage}>
                        <img
                          src={stepContent.clientLogo}
                          alt=""
                          className={styles.imageContain}
                        />
                      </div>
                      <Button
                        variant="outline"
                        size="sm"
                        className={styles.logoResetButton}
                        onClick={onClose}
                      >
                        <CameraAltOutlinedIcon className={styles.iconLarger} />
                      </Button>
                    </div>
                  ) : (
                    <div className={styles.logoPlaceholder}>
                      <div className={styles.logoCircle}>
                        <Building className="h-10 w-10 text-gray-400"/>
                      </div>
                      <p className={`${styles.logoNote} dark:text-white`}>Choose a company logo</p>
                      <p className={`${styles.logoSubNote} dark:text-white`}>PNG, JPG up to 2MB</p>
                      {stepError?.clientLogo && (
                        <span className="small error color-danger">
                          {stepError.clientLogo}
                        </span>
                      )}
                      <Button
                        variant="outline"
                        className={styles.logoUploadButton}
                        asChild
                      >
                        <label className="d-flex flex-center">
                          <FileUploadOutlinedIcon
                            className={styles.iconSmaller}
                          />{" "}
                          Upload logo
                          <input
                            type="file"
                            accept="image/jpeg, image/png"
                            onChange={handleLogoUpload}
                            style={{ display: "none" }}
                          />
                        </label>
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="mt-32 mb-16">
        <Card className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
          <CardContent className="p-24">
            <div className="d-flex flex-center flex-space-between mb-24">
              <h2 className={`${styles.cardProfileTitle} dark:text-white`}>
                <LocationOnOutlinedIcon
                  className={styles.iconSmaller}
                  style={{ color: "hsl(142, 72%, 29%)" }}
                />
                Address Information
              </h2>
              {/* {!isMobile && (
                <Button
                  variant="outline"
                  className={styles.logoUploadButton}
                  onClick={() => setMap(!map)}
                >
                  <div className="d-flex flex-center">
                    <LocationOnOutlinedIcon className={styles.iconSmaller} />
                    <span className="ml-10">
                      {map ? "Switch to Form Fields" : "View on Map"}
                    </span>
                  </div>
                </Button>
              )} */}
            </div>

            {!map && (
              <div>
                <div
                  className={
                    isMobile
                      ? "d-flex flex-direction-column flex-center mv-25"
                      : "d-flex flex-space-between flex-center w-100 mv-25"
                  }
                >
                  <div className="w-100">
                    <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                      Street Address
                    </Typography>
                    <div className="mt-5">
                      <Input
                        id="address"
                        placeholder="Address *"
                        value={stepContent?.addressInfo?.address || ""}
                        onChange={(e) =>
                          handleManualAddressChange("address", e.target.value)
                        }
                        tabIndex={6}
                      />
                      {stepError?.address && (
                        <span className="small error color-danger">
                          {stepError.address}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className={isMobile ? "w-100 mt-20" : "w-100 ml-20"}>
                    <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                      City
                    </Typography>
                    <div className="mt-5">
                      <Input
                        id="city"
                        placeholder="City *"
                        disabled={!stepContent?.addressInfo?.address}
                        value={stepContent?.addressInfo?.city || ""}
                        onChange={(e) =>
                          handleManualAddressChange("city", e.target.value)
                        }
                        tabIndex={7}
                      />
                      {stepError?.city && (
                        <span className="small error color-danger">
                          {stepError.city}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className={
                    isMobile
                      ? "d-flex flex-direction-column flex-center mv-25"
                      : "d-flex flex-space-between flex-center w-100 mv-25"
                  }
                >
                  <div className="w-100">
                    <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                      State
                    </Typography>
                    <SingleSelectNew
                      id="state"
                      placeholder="State *"
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      disabled={!stepContent?.addressInfo?.city}
                      value={stepContent?.addressInfo?.state || ""}
                      options={US_STATES}
                      onChange={(e) =>
                        handleManualAddressChange("state", e)
                      }
                      tabIndex={8}
                    />
                    {stepError?.state && (
                      <span className="small error color-danger">
                        {stepError.state}
                      </span>
                    )}
                  </div>
                  <div className={isMobile ? "w-100 mt-20" : "w-100 ml-20"}>
                    <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                      ZIP Code
                    </Typography>
                    <Input
                      id="zip"
                      placeholder="Zip *"
                      disabled={!stepContent?.addressInfo?.state}
                      value={stepContent?.addressInfo?.zip || ""}
                      onChange={(e) =>
                        handleManualAddressChange("zip", e.target.value)
                      }
                      tabIndex={9}
                    />
                    {stepError?.zip && (
                      <span className="small error color-danger">
                        {stepError.zip}
                      </span>
                    )}
                  </div>
                </div>
                <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                  Additional Notes
                </Typography>
                <Textarea
                  value={stepContent?.additionalNotes || ""}
                  onChange={handleInputChange}
                  id="additionalNotes"
                  name="additionalNotes"
                  placeholder="Enter any additional notes about this client"
                  tabIndex={10}
                />
              </div>
            )}
            {/* {map && (
              <div>
                <Typography className={styles.labelSm}>
                  Company Map Location
                </Typography>
                <div style={{ width: "100%", height: 200 }}>
                  <AddressByMap
                    onChangeAddress={onChangeAddress}
                    addressInfo={stepContent?.addressInfo}
                  />
                </div>
              </div>
            )} */}
            {/* {isMobile && (
              <Button
                variant="outline"
                className={`${styles.logoUploadButton} mt-20 w-100`}
                onClick={() => setMap(!map)}
              >
                <div className="d-flex flex-center">
                  <LocationOnOutlinedIcon className={styles.iconSmaller} />
                  <span className="ml-10">
                    {map ? "Switch to Form Fields" : "View on Map"}
                  </span>
                </div>
              </Button>
            )} */}
          </CardContent>
        </Card>
      </div>

      <div className="buttonsWrap d-flex flex-center flex-space-between mv-20">
        <Button
          variant="outline"
          className="bg-white dark:bg-gray-800 mr-15"
          disabled={loading}
          onClick={onCancelAll}
        >
          Back
        </Button>
        <Button
          color="primary"
          variant="contained"
          className={isMobile  ? "ml-15 bg-green color-white" : "w-full sm:w-auto mr-15 bg-green color-white"}
          onClick={() => validateAndGoNext()}
          disabled={loading}
        >
          <Save className="mr-2 h-4 w-4" /> {loading ? "Loading..." : "Save & Proceed"}
          <ArrowRight className="ml-1 h-4 w-4" />
        </Button>
      </div>

      {dialogOpen && (
        <CommonConfirmationDialog
          open={dialogOpen}
          onConfirm={handelUpdateAddress}
          onClose={handelCloseDailog}
          title="Address Update"
          message="Please note that changing this address will update the address for this client across all past, current, and future appointments."
          buttonTitle="Yes"
        />
      )}
      {storageDialog && (
        <StorageLimitAccess
          open={storageDialog}
          onClose={handleDialogClose}
          auth={auth}
        />
      )}
    </>
  );
}
export default Step1;
